import React from 'react';
import { Helmet } from 'react-helmet-async';
import PackageCard from '../components/services/PackageCard';
import FeatureBox from '../components/ui/FeatureBox';
import ProcessStep from '../components/ui/ProcessStep';
import CTASection from '../components/ui/CTASection';
import FAQ from '../components/ui/FAQ';
import { webDesignContent } from '../content/webDesign';
import './WebDesign.css';

const WebDesign = () => {
  return (
    <>
      <Helmet>
        <title>تصميم المواقع الإلكترونية - نمو ماركتينج</title>
        <meta
          name="description"
          content="نصمم لك موقع إلكتروني سريع، متجاوب، وسهل الاستخدام يساعدك على جذب العملاء وزيادة مبيعاتك"
        />
      </Helmet>

      <div className="web-design-page">
        {/* Hero Section */}
        <section className="page-hero">
          <div className="container">
            <div className="page-hero-content">
              <h1 className="page-hero-title">{webDesignContent.hero.title}</h1>
              <p className="page-hero-subtitle">{webDesignContent.hero.subtitle}</p>
            </div>
          </div>
        </section>

        {/* Why You Need a Website */}
        <section className="section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{webDesignContent.whyNeed.title}</h2>
              <p className="section-subtitle">{webDesignContent.whyNeed.subtitle}</p>
            </div>
            <div className="grid grid-4">
              {webDesignContent.whyNeed.reasons.map((reason) => (
                <FeatureBox
                  key={reason.id}
                  icon={reason.icon}
                  title={reason.title}
                  description={reason.description}
                />
              ))}
            </div>
          </div>
        </section>

        {/* What We Offer */}
        <section className="section bg-light">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{webDesignContent.whatWeOffer.title}</h2>
            </div>
            <div className="features-list">
              {webDesignContent.whatWeOffer.features.map((feature) => {
                const FeatureIcon = feature.icon;
                return (
                  <div key={feature.id} className="feature-item">
                    <div className="feature-item-icon">
                      <FeatureIcon />
                    </div>
                    <div className="feature-item-content">
                      <h4 className="feature-item-title">{feature.title}</h4>
                      <p className="feature-item-description">{feature.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{webDesignContent.benefits.title}</h2>
              <p className="section-subtitle">{webDesignContent.benefits.subtitle}</p>
            </div>
            <div className="grid grid-4">
              {webDesignContent.benefits.items.map((item) => (
                <FeatureBox
                  key={item.id}
                  icon={item.icon}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Portfolio Section */}
        <section className="section portfolio-section bg-light">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{webDesignContent.portfolio.title}</h2>
              <p className="section-subtitle">{webDesignContent.portfolio.subtitle}</p>
            </div>
            <div className="portfolio-grid">
              {webDesignContent.portfolio.projects.map((project) => (
                <div key={project.id} className="portfolio-item">
                  <div className="portfolio-item-image">
                    <img src={project.image} alt={project.title} />
                    <div className="portfolio-item-overlay">
                      <div className="portfolio-item-overlay-content">
                        <span className="portfolio-item-category">{project.category}</span>
                        <h3 className="portfolio-item-title">{project.title}</h3>
                        <p className="portfolio-item-description">{project.description}</p>
                        <div className="portfolio-item-features">
                          {project.features.map((feature, index) => (
                            <span key={index} className="portfolio-feature-tag">{feature}</span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Technologies */}
        <section className="section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{webDesignContent.technologies.title}</h2>
              <p className="section-subtitle">{webDesignContent.technologies.subtitle}</p>
            </div>
            <div className="grid grid-4">
              {webDesignContent.technologies.tools.map((tool) => (
                <FeatureBox
                  key={tool.id}
                  icon={tool.icon}
                  title={tool.title}
                  description={tool.description}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Packages - THE MOST IMPORTANT SECTION! */}
        <section className="section packages-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{webDesignContent.packagesSection.title}</h2>
              <p className="section-subtitle">{webDesignContent.packagesSection.subtitle}</p>
            </div>
            <div className="packages-grid">
              {webDesignContent.packages.map((pkg) => (
                <PackageCard
                  key={pkg.id}
                  title={pkg.title}
                  subtitle={pkg.subtitle}
                  description={pkg.description}
                  features={pkg.features}
                  badge={pkg.badge}
                  isFeatured={pkg.isFeatured}
                  whatsappMessage={pkg.whatsappMessage}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Design Process */}
        <section className="section bg-light">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{webDesignContent.process.title}</h2>
            </div>
            <div className="process-grid">
              {webDesignContent.process.steps.map((step) => (
                <ProcessStep
                  key={step.id}
                  number={step.number}
                  icon={step.icon}
                  title={step.title}
                  description={step.description}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Guarantees */}
        <section className="section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{webDesignContent.guarantee.title}</h2>
            </div>
            <div className="grid grid-4">
              {webDesignContent.guarantee.items.map((item) => (
                <FeatureBox
                  key={item.id}
                  icon={item.icon}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <FAQ title={webDesignContent.faq.title} items={webDesignContent.faq.items} />

        {/* Final CTA */}
        <CTASection
          title={webDesignContent.finalCTA.title}
          subtitle={webDesignContent.finalCTA.subtitle}
          buttonText={webDesignContent.finalCTA.buttonText}
          backgroundStyle="gradient"
        />
      </div>
    </>
  );
};

export default WebDesign;
